module.exports = __webpack_public_path__ + "img/usergroup_white.2c0a1aca.svg";